import * as client from "../../../client";
import { DBPerilType } from "../general-input/util";
import { EnrichmentSource, EnrichmentVendor } from "../cat/types";
import { DisplayPerilDataSource } from "./SourceBadge";

// The vendors whose live runs a Source-column value prices from. The blend
// takes KatRisk for flood and RMS 22 + ICM elsewhere (premium_calc's
// _source_peril_value); "mix" rows aggregate several sources and name none.
export const enrichmentVendorsForSource = (
  source: DisplayPerilDataSource,
  peril: DBPerilType
): EnrichmentVendor[] => {
  switch (source) {
    case "air":
      return ["icm_ylt"];
    case "rms":
      return ["rms_elt"];
    case "rms_22":
      return ["rms_22"];
    case "spatialkat":
      return ["spatialkat"];
    case "rms_22_air_50_50":
      return peril === "flood" ? ["spatialkat"] : ["rms_22", "icm_ylt"];
    case "lum":
      return ["rater"];
    case "eqbd":
      return ["eqbd_rater"];
    case "mix":
      return [];
  }
};

// The vendor data each vendor's live run modeled with; a vendor with no live
// run is absent.
export const liveSourcesByVendor = (
  state: client.VendorEnrichmentState | undefined
): Map<EnrichmentVendor, EnrichmentSource> =>
  new Map(
    (state?.vendors ?? [])
      .filter((v) => v.has_live_run)
      .map((v) => [v.vendor, v.live_source])
  );
